import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { gql } from 'graphql-request'

import { useGraphQLClient } from '@/hooks/useGraphQLClient'

const GET_MICRO_SITE_QUERY = gql`
  query ($id: ID!) {
    getMicroSite(id: $id) {
      id
      name
      logo
    }
  }
`

export interface MicroSite {
  id: string
  name: string
  logo: string
}

interface GetMicroSiteQueryResponse {
  getMicroSite: MicroSite
}

export const useGetMicroSiteApi = (
  microSiteId: string | null,
): UseQueryResult<MicroSite, Error> => {
  const client = useGraphQLClient()

  const fetchMicroSite = async (microSiteId: string | null): Promise<MicroSite> => {
    const data = await client.request<GetMicroSiteQueryResponse>(GET_MICRO_SITE_QUERY, {
      id: microSiteId,
    })

    return data.getMicroSite
  }

  return useQuery<MicroSite, Error>({
    queryKey: [microSiteId],
    enabled: !!microSiteId,
    queryFn: () => fetchMicroSite(microSiteId),
  })
}
